import { useCallback } from 'react';
import useAnalytics, {
  getSellerProperties,
  getVinBasicProperties,
  getVinLaunchProperties
} from './useAnalytics';
import MixpanelConfig from '../constants/mixpanelConfig';
import { TradeStateName, TradeContextName } from '../types/trade';
import isOmpPlatform from '../utils/isOmpPlatform';
import SegmentConfig from '../constants/segmentConfig';

interface ITrackMultiMediaGallery {
  tradeDetails: any;
  tradeState: number;
  mediaList: any;
  tradeContext: number;
  galleryOpenType: string;
}
/**
 * Hook is responsible for tracking MultiMediaGallery interactions
 * from the VDP (multimedia button, disclosure, multimedia photo)
 */
const useTrackMultiMediaGallery = () => {
  const track = useAnalytics();

  const trackMultiMediaGallery = useCallback(
    ({
      tradeDetails,
      tradeState,
      mediaList,
      tradeContext,
      galleryOpenType
    }: ITrackMultiMediaGallery) => {
      if (isOmpPlatform()) {
        track(SegmentConfig.names.vdpOpenMultimediaGallery, {
          ...getVinBasicProperties(tradeDetails),
          ...getVinLaunchProperties(tradeDetails),
          ...getSellerProperties(tradeDetails),
          total_damage_images: mediaList.meta?.count?.damages,
          total_overview_images: mediaList.meta?.count?.photos,
          total_videos: mediaList.meta?.count?.videos,
          gallery_open_type: galleryOpenType
        });
      } else {
        track(MixpanelConfig.names.openMultiMediaGallery, {
          trade_id: tradeDetails.id,
          auction_id: tradeDetails.auctionSummary?.id,
          vin: tradeDetails.vin,
          year: tradeDetails.year,
          make: tradeDetails.manufacturerName,
          model: tradeDetails.modelName,
          trim: tradeDetails.trim,
          as_is: tradeDetails.isAsIs,
          trade_state: TradeStateName[tradeState],
          trade_state_section: TradeContextName[tradeContext],
          disclosures: '',
          source: `Disclosure image`,
          overview_images: mediaList.meta?.count?.photos,
          disclosure_images: mediaList.meta?.count?.damages,
          videos: mediaList.meta?.count?.videos,
          seller_dealer_name: tradeDetails.dealer.displayName,
          seller_dealer_id: tradeDetails.dealer.id
        });
      }
    },
    [track]
  );

  return trackMultiMediaGallery;
};

export default useTrackMultiMediaGallery;
